import { againstNullOrUndefined } from '@carvector/shared/util-guards';
import { Nullable } from '@carvector/shared/util-type-fest';

export const againstAtLeast = (input: string, size = 1) => input.length >= size;

export const notEmpty = (input: Nullable<string>) =>
  againstNullOrUndefined(input) && againstAtLeast(input);
